import { Helmet } from "react-helmet";
import PayBenefitsSection from "./components/PayBenefitsSection";
import PayCommandCentreSection from "./components/PayCommandCentreSection";
import PayEcosystemSection from "./components/PayEcosystemSection";
import PayFaqSection from "./components/PayFaqSection";
import PayFinalCtaSection from "./components/PayFinalCtaSection";
import PayHeaderSection from "./components/PayHeaderSection";
import PayPeopleSection from "./components/PayPeopleSection";
import PayProcessSection from "./components/PayProcessSection";
import PaySupportSection from "./components/PaySupportSection";
import PayWhySection from "./components/PayWhySection";
import SiteFooter from "../../components/layout/SiteFooter";

const Pay = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva Pay | Global payroll, made human</title>
        <meta
          name="description"
          content="Coordinate payroll for remote employees and contractors across borders with one clear process and real people beside you."
        />
        <meta
          property="og:title"
          content="Utiva Pay | Global payroll, made human"
        />
        <meta
          property="og:description"
          content="Pay people everywhere. Keep the experience personal."
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <PayHeaderSection />
      <PayEcosystemSection />
      <PayWhySection />
      <PayCommandCentreSection />
      <PayBenefitsSection />
      <PaySupportSection />
      <PayProcessSection />
      <PayPeopleSection />
      <PayFaqSection />
      <PayFinalCtaSection />
      <SiteFooter />
    </div>
  );
};

export default Pay;
